import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

export default function DisclaimerPage() {
  return (
    <>
      <Navbar />
      <main className="pt-24 pb-16 min-h-screen bg-[#F8F6F2]" data-testid="disclaimer-page">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white p-8 lg:p-12 shadow-sm border border-gray-100">
            <h1 
              className="text-3xl sm:text-4xl font-bold text-[#0B1C2D] mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Disclaimer
            </h1>
            <div className="w-20 h-1 bg-[#C6A34A] mb-8" />

            <div className="prose prose-gray max-w-none text-[#4A5568]">
              <p className="text-sm text-[#718096] mb-6">
                Last Updated: January 2026
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Bar Council of India Rules
              </h2>
              <p className="mb-4 leading-relaxed">
                As per the rules of the Bar Council of India, advocates and law firms are not permitted to solicit 
                work or advertise in any form or manner. This website has been designed only for the purpose of 
                dissemination of basic information about the Chambers of Adv. Ajeet Narayan Sinha.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                No Solicitation
              </h2>
              <p className="mb-4 leading-relaxed">
                The information provided on this website is for general informational purposes only and should 
                not be construed as solicitation of work or advertisement. There has been no advertisement, 
                personal communication, solicitation, invitation, or inducement of any sort whatsoever from us 
                or any of our members to solicit any work through this website.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                No Attorney-Client Relationship
              </h2>
              <p className="mb-4 leading-relaxed">
                Use of this website, submission of the contact/inquiry form, sending emails to addresses mentioned 
                on this website, or any other communication through this website does not create an attorney-client 
                relationship. Any information obtained or materials downloaded from this website is completely at 
                the user's volition and any transmission, receipt, or use of this site would not create any 
                attorney-client relationship.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Information Only
              </h2>
              <p className="mb-4 leading-relaxed">
                The contents of this website are intended for informational purposes only. Users are advised to 
                seek formal legal advice prior to acting upon any information provided on this website. The 
                information contained on this website is not in the nature of a legal opinion or otherwise 
                amounts to any legal advice.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                No Liability
              </h2>
              <p className="mb-4 leading-relaxed">
                We are not liable for any consequence of any action taken by the user relying on material or 
                information provided under this website. Users should verify information independently and are 
                responsible for their own decisions. In cases of any dispute, the courts at Patna, Bihar shall 
                have exclusive jurisdiction.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                User Acknowledgment
              </h2>
              <p className="mb-4 leading-relaxed">
                By continuing to browse and access this website, the user acknowledges that:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>There has been no solicitation, advertisement, or inducement from our side.</li>
                <li>The user wishes to gain more information about us for their own information and use.</li>
                <li>The information is provided upon specific request of the user.</li>
                <li>This website does not constitute legal advice.</li>
                <li>No attorney-client relationship is created through use of this website.</li>
              </ul>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Contact Information
              </h2>
              <p className="mb-4 leading-relaxed">
                For any queries regarding this disclaimer, please contact:<br />
                Email: ajeet.sinha@jurisbihar.com<br />
                Phone: +91 9431078694
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
